// extracted by mini-css-extract-plugin
module.exports = {"subHeadingText":"CbH3","verifyHeading":"_9R9O","textColour":"PDU5"};